import { useState, useRef, useEffect } from 'react';
import SharkyRunning from "../../assets/images/Sharky/Sharky_Running.png"
import './Solutions.css'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { useGSAP } from '@gsap/react'
import { useTranslation } from 'react-i18next';
import CorporativeVol from './Desktop/CorporativeVol';
import Sponsorship from './Desktop/Sponsorship';
import Sharky from './Desktop/Sharky';
import SustMerch from './Desktop/SustMerch';
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)


function SolutionsDesktop() {
  const { t } = useTranslation(['common']);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const solutionsRef = useRef();
  const [domReady, setDomReady] = useState(false);
    // dom loaded
    useEffect(() => {
        const checkDOMReady = () => {
            const animatedBox = document.querySelector('#section-solutions');
            
            if (animatedBox) {
                setDomReady(true);
            } else {
                requestAnimationFrame(checkDOMReady);
            }
        };

        setTimeout(checkDOMReady, 50);
    }, []);

  useGSAP(() => {
        if (!domReady) return;
        const ctx = gsap.context(() => {
        // Obtener todos los elementos con la clase
        const textElements = gsap.utils.toArray(".solutions-text-appear");
        
        textElements.forEach((element) => {
            let split = SplitText.create(element, {
            type: "lines"
            });
            
            gsap.from(split.lines, {
            scrollTrigger: {
                trigger: element, // Cada elemento es su propio trigger
                start: "top 60%",
                end: "+=150",
                scrub: true,
                markers: false //only dev
            },
            y: 50,
            autoAlpha: 0,
            stagger: 0.05
            });
        });
        });

    return () => ctx.revert(); // 🔄 Limpieza automática
    }, {scope: solutionsRef});
  

  return (
    <div ref={solutionsRef} id='section-solutions' className='flex flex-col items-start justify-start pt-20 w-full bg-bluekali-tomato overflow-hidden'>
      <h1 className="text-5xl font-bold pl-6">
        {t('solutions.title1')} <span className="text-bluekali-cerulean-blue">{t('solutions.title2')}</span>
      </h1>
      <img 
        src={SharkyRunning} 
        alt="" 
        className="absolute right-0 rotate-6 -scale-x-[1] z-10 h-36 mr-16 shadow-right transform -translate-y-[70px]"
      />
      <div className="flex w-full h-[600px] overflow-hidden">
        <CorporativeVol
            isExpanded={expandedIndex === 0}
            onToggle={() => setExpandedIndex(expandedIndex === 0 ? null : 0)}
          />
        <Sponsorship
          isExpanded={expandedIndex === 1}
          onToggle={() => setExpandedIndex(expandedIndex === 1 ? null : 1)}
        />
        <Sharky
          isExpanded={expandedIndex === 2}
          onToggle={() => setExpandedIndex(expandedIndex === 2 ? null : 2)}
        />
        <SustMerch
          isExpanded={expandedIndex === 3}
          onToggle={() => setExpandedIndex(expandedIndex === 3 ? null : 3)}
        />
      </div>
    </div>
  );
}

export default SolutionsDesktop;